import {
  ENDPOINTS,
  ShipmentType,
  TABLE_BODY_MAX_HEIGHT_WITHOUT_TABS,
  TableName,
  TransportJobTabType,
  WebTable
} from '@constants';
import AgTable from '@containers/AgTable';
import { useNewButton } from '@hooks';
import useAgInfTable from '@hooks/core/useAgInfTable';
import { IUseAgInfTableProps } from '@hooks-dto';
import { useOpenTransportJobDetail } from '@pages/TransportJob/helpers';
import { memo, useCallback, useMemo, useState } from 'react';
import trans from 'translation';
import { KButton, KContainer, KTab } from 'uikit';

import { colDefs } from './helpers';

interface IProps {
  shipmentType: ShipmentType;
  onChangeShipmentType: (shipmentType: ShipmentType) => void;
}

const ListGeneralFreight = ({ shipmentType, onChangeShipmentType }: IProps) => {
  const [status, setStatus] = useState(TransportJobTabType.Active);

  const { onAdd } = useOpenTransportJobDetail(shipmentType);

  const tabs = useMemo(() => {
    const _tabs = Object.keys(ShipmentType).map(
      (i: keyof typeof ShipmentType) => ({
        key: ShipmentType[i],
        label: trans(i.toLowerCase()).toUpperCase()
      })
    );

    return _tabs?.filter(t => t?.key !== ShipmentType.FCL);
  }, []);

  const onChangeTab = useCallback(
    (v: ShipmentType) => {
      onChangeShipmentType(v);
    },
    [onChangeShipmentType]
  );

  const newButton = useNewButton({
    onPress: onAdd
  });

  const leftNode = useMemo(() => {
    const keys = Object.keys(TransportJobTabType);
    const _tabs = keys.map(i => (TransportJobTabType as any)[i]);

    return (
      <KContainer.View dp="flex" row gap={6}>
        {_tabs.map(i => {
          const isActive = status === i;
          if (isActive) {
            return (
              <KButton.Solid
                key={`lcl-lse-status-${i}`}
                title={trans(i.toLowerCase()).toUpperCase()}
                hasShadow={false}
              />
            );
          }
          return (
            <KButton.Outline
              key={`lcl-lse-status-${i}`}
              title={trans(i.toLowerCase())}
              onPress={() => setStatus(i)}
              kind="normal"
            />
          );
        })}
      </KContainer.View>
    );
  }, [status]);

  const tableProps = useMemo(
    (): IUseAgInfTableProps<any> => ({
      name: WebTable.TRANSPORT_JOB,
      tableName: TableName.TRANSPORT_JOB,
      apiURL: ENDPOINTS.transportJob(),
      colDefs: colDefs(),
      onAdd: () => {},
      showFilter: true,
      isInitFetch: true,
      otherParams: {
        shipmentType,
        tabType: status
      }
    }),
    [shipmentType, status]
  );

  const table = useAgInfTable(tableProps);
  return (
    <>
      <KContainer.Card
        marginT={'0.25rem'}
        header={{
          renderHeader: () => (
            <KContainer.View marginB={'0.75rem'}>
              <KTab.Outline
                initialIndex={0}
                onChangeTab={onChangeTab}
                tabs={tabs}
                marginT={'0.25rem'}
              />
            </KContainer.View>
          )
        }}
      >
        <AgTable
          {...table}
          showSearch
          pagination
          leftNode={leftNode}
          height={TABLE_BODY_MAX_HEIGHT_WITHOUT_TABS}
          onAdd={onAdd}
        />
      </KContainer.Card>
      {newButton}
    </>
  );
};

export default memo(ListGeneralFreight);
